/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1ExamRevisionPublishMutationRequest,
  PostApiV1ExamRevisionPublishMutationResponse,
  PostApiV1ExamRevisionPublish400,
  PostApiV1ExamRevisionPublish401,
  PostApiV1ExamRevisionPublish404,
  PostApiV1ExamRevisionPublish500,
} from "../../types/examRevisionController/PostApiV1ExamRevisionPublish.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1ExamRevisionPublish } from "../../clients/examRevisionController/postApiV1ExamRevisionPublish.ts";

export const postApiV1ExamRevisionPublishMutationKey = () =>
  [{ url: "/api/v1/exam/revision/publish" }] as const;

export type PostApiV1ExamRevisionPublishMutationKey = ReturnType<
  typeof postApiV1ExamRevisionPublishMutationKey
>;

export function postApiV1ExamRevisionPublishMutationOptions<TContext = unknown>(
  config: Partial<
    RequestConfig<PostApiV1ExamRevisionPublishMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1ExamRevisionPublishMutationKey();
  return mutationOptions<
    PostApiV1ExamRevisionPublishMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionPublish400
      | PostApiV1ExamRevisionPublish401
      | PostApiV1ExamRevisionPublish404
      | PostApiV1ExamRevisionPublish500
    >,
    { data?: PostApiV1ExamRevisionPublishMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1ExamRevisionPublish(data, config);
    },
  });
}

/**
 * @description Publica uma avaliação gerada por IA: cria a prova (Exam) do tipo Avaliação do Aluno, copia os itens do BotExam para a nova prova, gera a publicação principal para a turma/disciplina com as datas e configurações informadas. Opcionalmente cria também a publicação da avaliação docente quando TeacherEvaluationExamId é informado. Atualiza o status do BotExam para Published. **(Requer Authorization para autenticação)**
 * @summary Publicar avaliação gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/publish}
 */
export function usePostApiV1ExamRevisionPublish<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1ExamRevisionPublishMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ExamRevisionPublish400
        | PostApiV1ExamRevisionPublish401
        | PostApiV1ExamRevisionPublish404
        | PostApiV1ExamRevisionPublish500
      >,
      { data?: PostApiV1ExamRevisionPublishMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1ExamRevisionPublishMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1ExamRevisionPublishMutationKey();

  const baseOptions = postApiV1ExamRevisionPublishMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1ExamRevisionPublishMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionPublish400
      | PostApiV1ExamRevisionPublish401
      | PostApiV1ExamRevisionPublish404
      | PostApiV1ExamRevisionPublish500
    >,
    { data?: PostApiV1ExamRevisionPublishMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1ExamRevisionPublishMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionPublish400
      | PostApiV1ExamRevisionPublish401
      | PostApiV1ExamRevisionPublish404
      | PostApiV1ExamRevisionPublish500
    >,
    { data?: PostApiV1ExamRevisionPublishMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1ExamRevisionPublishMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionPublish400
      | PostApiV1ExamRevisionPublish401
      | PostApiV1ExamRevisionPublish404
      | PostApiV1ExamRevisionPublish500
    >,
    { data?: PostApiV1ExamRevisionPublishMutationRequest },
    TContext
  >;
}
